import { render, staticRenderFns } from "./FormationCatalogueDetailComponent.vue?vue&type=template&id=3d7491a5&"
import script from "./FormationCatalogueDetailComponent.vue?vue&type=script&lang=js&"
export * from "./FormationCatalogueDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormationCatalogueDetailComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports